import React from 'react'

import Garbage from 'assets/svg/garbage.svg'
import StringFormat from 'utils/StringFormat'

import * as product from 'constants/product-types'
import { aleloPodGroups } from 'constants/pod-groups'
import { aleloTudoGroups } from 'constants/alelo-tudo-groups'

import {
    Container,
    Desc,
    Card,
    Trash,
    Spacer,
    Content,
    Group,
    Label,
    Value,
    GroupLabel,
    CardImage,
    Header
} from './CartListItem.style'
import { FLAGS, useFeatureFlag } from 'components/ff4j'
import { PodTiffany } from 'assets/img/cards'

const productGroups = {
    [product.TUDO]: aleloTudoGroups,
    [product.POD]: aleloPodGroups
}

const PodAndTudo = [product.TUDO, product.POD]

const CartListItem = ({ product, index, openModal }) => {
    const segregecaoEnabled = useFeatureFlag(FLAGS.SEGREGACAO_CNPJ)

    const getImage = (product) => {
        const image = StringFormat.renderTraditionalImg(+product.id)

        if (segregecaoEnabled && product.id === 700) {
            return PodTiffany
        }

        return image
    }

    return (
        <Container id={`cartMenuList${StringFormat.cardKind(product.id)}`}>
            <Card>
                <CardImage
                    $isVertical={PodAndTudo.includes(product.id)}
                    src={getImage(product)}
                    alt="Alelo mini card"
                />
            </Card>

            <Content>
                <Header $isVertical={PodAndTudo.includes(product.id)}>
                    <Desc>{StringFormat.nameProducts(product.id)}</Desc>
                    <Trash
                        id={`cartTrash${StringFormat.cardKind(product.id)}`}
                        onClick={() =>
                            openModal(
                                product.id,
                                product.value,
                                product.qnt,
                                index
                            )
                        }
                    >
                        <img src={Garbage} alt="Alelo Garbage" />
                    </Trash>
                </Header>
                {product.groups ? (
                    product.groups.items
                        .filter((group) => group.qnt > 0 && group.value > 0)
                        .map((group) => {
                            const groupInfo = productGroups[product.id].find(
                                (g) =>
                                    g.type === group.type ||
                                    g.type === group.desc
                            )

                            return (
                                <Group key={group.type}>
                                    <GroupLabel>{groupInfo?.desc}</GroupLabel>
                                    <Spacer>
                                        <Label>Qtde de colaboradores</Label>
                                        <Value>{group.qnt}</Value>
                                    </Spacer>
                                    <Spacer>
                                        <Label>Valor mensal por colab.</Label>
                                        <Value>
                                            {StringFormat.convertToMonetary(
                                                parseFloat(group.value).toFixed(
                                                    2
                                                )
                                            )}
                                        </Value>
                                    </Spacer>
                                </Group>
                            )
                        })
                ) : (
                    <Group>
                        <Spacer>
                            <Label>Qtde de cartões</Label>
                            <Value>{product.qnt}</Value>
                        </Spacer>
                        <Spacer>
                            <Label>Valor por cartão</Label>
                            <Value>
                                {StringFormat.convertToMonetary(
                                    parseFloat(product.value).toFixed(2)
                                )}
                            </Value>
                        </Spacer>
                    </Group>
                )}
            </Content>
        </Container>
    )
}

export default CartListItem
